
export enum UserStatus {
  IsDeleted = 1,
  IsApproved = 2,
  IsLocked = 4,
  IsHidden = 8
}
